module.exports = __webpack_public_path__ + "fonts/Rubik-ExtraBold.1ab45dd.ttf";